<div
  class="version-update-banner"
  data-testid="version-update-banner"
  (click)="onUpdate()"
>
  <div class="version-update-banner__icon">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z"
        fill="currentColor"
      />
    </svg>
  </div>

  <div class="version-update-banner__content">
    <span class="version-update-banner__title">
      {{ 'VERSION_UPDATE.TITLE' | translate }}
    </span>
    <span *ngIf="releaseMessage" class="version-update-banner__description">
      {{ releaseMessage }}
    </span>
    <span class="version-update-banner__message">
      {{ 'VERSION_UPDATE.MESSAGE' | translate }}
    </span>
  </div>

  <button
    class="version-update-banner__close"
    data-testid="version-update-dismiss"
    (click)="onDismiss($event)"
    [attr.aria-label]="'VERSION_UPDATE.DISMISS' | translate"
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
        fill="currentColor"
      />
    </svg>
  </button>
</div>
